<template lang="html">
  <div>
    <a v-for="course in championship.courses" @click="selectCourse(course)"
       class="btn btn-default" v-bind:class="{'active': course.id == current_course.id }">{{course.name}}</a>
    <div class="rondaSelect">
      <a v-for="date in championship.dates | orderBy 'date'" @click="selectDate(date, $index)"
      class="btn btn-default" v-bind:class="{'active': date.id == current_date.id }">
        Ronda {{ $index + 1}}
      </a>
    </div>
    <players-list></players-list>
  </div>
</template>

<script>
import configure from '../configure'
import {
  getCurrentChampionship,
  getCurrentCourse,
  getCurrentDate
} from '../vuex/getters'
import * as actions from '../vuex/actions'
import PlayersList from '../components/PlayersList'
export default {
  vuex: {
    getters: {
      championship: getCurrentChampionship,
      current_course: getCurrentCourse,
      current_date: getCurrentDate
    },
    actions: actions
  },
  data() {
    return {
    }
  },
  methods: {
    selectDate(date, index) {
      this.$progress.start()
      this.setLoading(true)
      date.name = 'Ronda ' + (parseInt(index) + 1)
      this.getRegistrations().then(() => {
        this.setDate(date)
        this.$progress.finish()
        this.setLoading(false)
      })
    },
    selectCourse(course) {
      this.setLoading(true)
      this.$progress.start()
      this.$http.get(
        configure.api_url + 'courses/' + course.id
      ).then((response) => {
        this.course = response.data.course;
        this.setCourse(this.course)
        this.getRegistrations().then(response => {

        })
        this.$progress.finish()
        this.setLoading(false)
      }, (error) => {
        this.setError({show: true, message:'Failed getting this course'})
        this.$progress.failed()
        this.setLoading(false)
      })
    },
    getRegistrations() {
      return this.$http.get(
        configure.api_url
        + 'registrations?championship_id='
        + this.championship.id
        + '&status=3&course_id='
        + this.current_course.id
      ).then((response) => {
        this.setRegistrations(response.data)
        this.setPlayersReady([])
        this.setPlayersWaiting([])
      }, (error) => {
        this.setError({show: true, message:'Failed fetching registrations'})
        this.$progress.failed()
      })
    }
  },
  components: { PlayersList }
};
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** Game.vue?58c634e4
 **/